export enum BookCollectionPrivacyEnum {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}
